import { render, staticRenderFns } from "./LegPODUpload.vue?vue&type=template&id=4dda29ea"
import script from "./LegPODUpload.vue?vue&type=script&lang=js"
export * from "./LegPODUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports